export default __webpack_public_path__ + "static/logistics-software-development-company-peerbits-a68ee263395047d55ffbcbf294ee3c77.png";